import styled, { createGlobalStyle } from 'styled-components'
import variables, { colors, device } from 'Styled/variables'

export const TargetInfo = styled.div`
  margin-bottom: 16px;
  width: 100%;
  padding: 16px 16px 24px 16px;
  background-color: ${colors.white};
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  @media ${device.mobileMin} {
    padding: 24px 88px 50px 88px;
  }
`
export const TargetGenresTitle = styled.div`
  display: flex;
  line-height: 21px;
  justify-content: space-between;
  font-size: 14px;
  color: ${colors.mainText};
  font-weight: 400;
  margin-bottom: 16px;
  @media ${device.mobileMin} {
    margin-bottom: 13px;
  }
`
export const MatchingInfoContainer = styled.div`
  display: flex;
  font-display: row;
  color: ${colors.messegesYellow1};
  align-items: flex-start;
  margin-bottom: 32px;
`

export const MatchingInfoIcon = styled.div`
  margin-right: 8px;
  width: 16px;
  height: 14px;

  & img {
    width: 16px;
    height: 14px;
  }
`
export const WrapperForLanguageCheckbox = styled.div`
  display: flex;
  flex-direction: row;
  color: ${colors.mainText};
  line-height: 21px;
  font-size: ${variables.fontSize14};
`

export const TargetLangTitle = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: ${colors.mainText};
  font-weight: 400;
  margin-bottom: 16px;
  @media ${device.mobileMin} {
    margin-bottom: 16px;
  }
`
export const GotItBtnContainer = styled.div`
  margin: 0 auto;
`

export const NeedHelpGenresBtn = styled.div`
  padding-left: 0;
  margin-bottom: 49.5px;
  color: ${colors.mainText};
  @media ${device.mobileMin} {
    margin-bottom: 50px;
  }
`

export const CopyOptionsWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 70.5px;
`
export const StyledPopover = styled.div``

export const GlobalStyled = createGlobalStyle`
.ant-popover-inner {
  border-radius: 8px;
}
 .ant-popover-arrow{
  display: none !important;
 }
 .ant-popover-inner-content{
    padding: 16px;
  }
  .ant-popover-inner {
    width: 288px
  }
`

export const Wrapper = styled.div`
  border-radius: 4px;
  display: flex;
  flex-direction: column;
`
export const StyledTitle = styled.div`
  padding-bottom: 16px;
`

export const BtnsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
